
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Options, Vue } from "vue-class-component";

import HotspotSwiper from "@/components/Common/HotspotSwiper.vue";
import HotspotContentList from "@/components/Common/HotspotContentList.vue";

@Options({
  components: {
    HotspotSwiper,
    HotspotContentList,
  },
  props: {
    modules: Object,
  },
  data() {
    return {};
  },
  methods: {
    audiobgstop() {
      this.$emit("audiobgstop");
    },
    click(k: number) {
      this.currentIndex = k;
      this.showDetail = true;
    },
  },
})
export default class Hotspot6 extends Vue {}
